var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 29,
    rx: 3,
    fill: "#678CA6",
    fillOpacity: 0.39
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9835 16.859C18.8753 15.7107 19.4386 14.2379 19.4386 12.6153C19.4386 8.97063 16.6458 6 13.2193 6C9.79281 6 7 8.97063 7 12.6153C7 16.2599 9.79281 19.2305 13.2193 19.2305C14.7213 19.2305 16.1294 18.6564 17.209 17.6828L22.0436 22.8253C22.161 22.9501 22.3018 23 22.4426 23C22.5834 23 22.7242 22.9501 22.8416 22.8253C23.0528 22.6006 23.0528 22.2012 22.8416 21.9765L17.9835 16.859ZM13.1958 18.0323C10.3795 18.0323 8.10304 15.6109 8.10304 12.6153C8.10304 9.61968 10.3795 7.19824 13.1958 7.19824C16.0121 7.19824 18.2886 9.61968 18.2886 12.6153C18.2886 15.6109 16.0121 18.0323 13.1958 18.0323Z",
    fill: "#678CA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon1);
export default __webpack_public_path__ + "static/media/Search_icon(1).5dcb01b09f173e15b9e24fb8d6c655ce.svg";
export { ForwardRef as ReactComponent };